import { render, staticRenderFns } from "./DetalleCorrectivaForm.vue?vue&type=template&id=3e53dba9&scoped=true&"
import script from "./DetalleCorrectivaForm.vue?vue&type=script&lang=ts&"
export * from "./DetalleCorrectivaForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleCorrectivaForm.vue?vue&type=style&index=0&id=3e53dba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e53dba9",
  null
  
)

export default component.exports